// @ts-nocheck
import axios from "axios"
import endpoints from '../../config/endpoints.config'

const refresh = async () => {
    return await axios.get(endpoints.auth.refresh, { withCredentials: true })
}

export default refresh